import { render, staticRenderFns } from "./forward.vue?vue&type=template&id=d9b6d080&scoped=true"
import script from "./forward.vue?vue&type=script&lang=js"
export * from "./forward.vue?vue&type=script&lang=js"
import style0 from "./forward.vue?vue&type=style&index=0&id=d9b6d080&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b6d080",
  null
  
)

export default component.exports